import {lazy, Suspense} from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import {Styles} from "../styles/styles";
import {HOME_PATH} from "../url";
import ScrollToTop from "../common/ScrollToTop";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <ScrollToTop />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
        <Redirect to={HOME_PATH} />
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
